// extracted by mini-css-extract-plugin
module.exports = {"faq-image":"FAQ_faq-image__ZNZ1F"};